import React from "react";
import "../Grocery.css";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { NavLink } from "react-router-dom";

import {
    FiHome,
    FiChevronRight,
    FiShoppingCart,
} from "react-icons/fi";


const Grocery = () => {

    return (

        <>

            <Header />


            {/* =====================================================
                            HERO SECTION
            ===================================================== */}


            <section className="grocery-hero">


                <div className="grocery-overlay"></div>



                <div className="container">


                    <div className="grocery-hero-content">



                        <span className="grocery-tag">

                            Grocery Technology Solutions

                        </span>




                        <h1>

                            Transforming
                            <span> Grocery Business </span>
                            Through Smart Digital Innovation

                        </h1>





                        <p>

                            Kishancart Digital (OPC) Private Limited
                            provides advanced digital solutions for
                            grocery stores, supermarkets, online grocery
                            platforms, distributors, and retail businesses.
                            We build smart grocery management systems
                            that improve inventory control, automate
                            operations, enhance customer experience,
                            and enable data-driven business growth.

                        </p>





                        <div className="grocery-hero-btns">


                            {/*

                            <NavLink
                                to="/contact"
                                className="primary-btn"
                            >

                                Contact Experts

                            </NavLink>



                            <NavLink
                                to="/services"
                                className="secondary-btn"
                            >

                                Explore Solutions

                            </NavLink>

                            */}


                        </div>




                    </div>



                </div>



            </section>







            {/* =====================================================
                            BREADCRUMB
            ===================================================== */}



            <section className="grocery-breadcrumb">


                <div className="container">


                    <div className="breadcrumb">



                        <NavLink to="/">

                            <FiHome />

                            Home

                        </NavLink>





                        <FiChevronRight />





                        <span>

                            Solutions

                        </span>





                        <FiChevronRight />





                        <span className="active">


                            <FiShoppingCart />

                            Grocery


                        </span>




                    </div>


                </div>



            </section>







            {/* =====================================================
                    GROCERY OVERVIEW
            ===================================================== */}



            <section className="grocery-overview">


                <div className="container">





                    <div className="overview-grid">





                        {/* LEFT CONTENT */}




                        <div className="overview-content">



                            <span className="section-tag">

                                Digital Grocery Solutions

                            </span>





                            <h2>

                                Smart Technology for
                                <span> Modern Grocery Business</span>

                            </h2>





                            <p>

                                Kishancart Digital (OPC) Private Limited
                                develops secure and scalable grocery
                                technology solutions that help grocery
                                retailers, supermarkets, wholesalers,
                                and online grocery businesses manage
                                operations efficiently.

                            </p>





                            <p>

                                Our digital grocery platforms simplify
                                inventory management, billing,
                                customer management, order processing,
                                delivery tracking, and business
                                analytics to create a complete digital
                                grocery ecosystem.

                            </p>






                            <div className="overview-list">



                                <div className="overview-item">

                                    ✓ Grocery Store Management System

                                </div>





                                <div className="overview-item">

                                    ✓ Online Grocery Platform

                                </div>





                                <div className="overview-item">

                                    ✓ Inventory & Stock Management

                                </div>





                                <div className="overview-item">

                                    ✓ Billing & POS Solutions

                                </div>





                                <div className="overview-item">

                                    ✓ Order & Delivery Management

                                </div>





                                <div className="overview-item">

                                    ✓ Grocery Analytics Dashboard

                                </div>




                            </div>





                        </div>









                        {/* RIGHT CARDS */}





                        <div className="overview-cards">





                            <div className="overview-card">



                                <h3>

                                    Grocery Store Management

                                </h3>




                                <p>

                                    Manage products, inventory,
                                    billing, suppliers, customers,
                                    and daily grocery operations
                                    through one centralized platform.

                                </p>



                            </div>








                            <div className="overview-card">



                                <h3>

                                    Online Grocery Platform

                                </h3>




                                <p>

                                    Build user-friendly grocery
                                    shopping platforms that allow
                                    customers to browse products,
                                    place orders, and track deliveries.

                                </p>



                            </div>








                            <div className="overview-card">



                                <h3>

                                    Inventory Automation

                                </h3>




                                <p>

                                    Track stock levels, manage
                                    product availability, automate
                                    restocking, and reduce inventory
                                    management errors.

                                </p>



                            </div>








                            <div className="overview-card">



                                <h3>

                                    Grocery Business Analytics

                                </h3>




                                <p>

                                    Analyze sales performance,
                                    customer behavior, inventory
                                    trends, and business growth
                                    with real-time dashboards.

                                </p>



                            </div>





                        </div>






                    </div>





                </div>





            </section>





            {/* 
                PART 2 STARTS HERE

                Grocery Challenges
                +
                Grocery Solutions

            */}

            {/* =====================================================
            GROCERY CHALLENGES
===================================================== */}


            <section className="grocery-challenges">


                <div className="container">


                    <div className="section-heading">


                        <span className="section-tag">

                            Industry Challenges

                        </span>




                        <h2>

                            Challenges in
                            <span> Modern Grocery Business Management</span>

                        </h2>





                        <p>

                            Grocery businesses face challenges related to
                            inventory control, customer management, order
                            processing, supply chain visibility, and operational
                            efficiency. Our digital grocery solutions help
                            businesses overcome these challenges with modern
                            technology.

                        </p>



                    </div>







                    <div className="challenge-grid">





                        <div className="challenge-card">


                            <h3>

                                Inventory Management

                            </h3>



                            <p>

                                Manage grocery products, stock availability,
                                expiry tracking, and automated inventory updates
                                to reduce wastage and improve efficiency.

                            </p>



                        </div>







                        <div className="challenge-card">


                            <h3>

                                Order Management

                            </h3>



                            <p>

                                Handle online and offline grocery orders,
                                processing, payment tracking, and customer
                                order fulfillment through digital platforms.

                            </p>



                        </div>








                        <div className="challenge-card">


                            <h3>

                                Customer Experience

                            </h3>



                            <p>

                                Provide seamless grocery shopping experiences
                                with personalized services, faster ordering,
                                and digital customer engagement.

                            </p>



                        </div>








                        <div className="challenge-card">


                            <h3>

                                Supply Chain Management

                            </h3>



                            <p>

                                Improve supplier coordination, product
                                availability, procurement planning, and
                                distribution management.

                            </p>



                        </div>








                        <div className="challenge-card">


                            <h3>

                                Billing & Operations

                            </h3>



                            <p>

                                Simplify billing processes, POS operations,
                                payment management, and daily grocery store
                                workflows.

                            </p>



                        </div>








                        <div className="challenge-card">


                            <h3>

                                Business Analytics

                            </h3>



                            <p>

                                Track sales performance, customer trends,
                                product demand, and business insights with
                                real-time analytics.

                            </p>



                        </div>





                    </div>



                </div>



            </section>









            {/* =====================================================
            GROCERY DIGITAL SOLUTIONS
===================================================== */}



            <section className="grocery-solutions">


                <div className="container">





                    <div className="section-heading">


                        <span className="section-tag">

                            Our Grocery Solutions

                        </span>





                        <h2>

                            Complete Digital Solutions for
                            <span> Grocery Industry</span>

                        </h2>






                        <p>

                            We develop scalable grocery technology solutions
                            that help retailers, supermarkets, wholesalers,
                            and online grocery businesses automate operations,
                            improve customer experience, and achieve sustainable
                            growth.

                        </p>




                    </div>








                    <div className="solutions-grid">







                        <div className="solution-card">


                            <h3>

                                Grocery Management System

                            </h3>



                            <p>

                                Manage grocery products, inventory, suppliers,
                                customers, billing, and daily store operations
                                from a centralized platform.

                            </p>



                        </div>









                        <div className="solution-card">


                            <h3>

                                Online Grocery Store

                            </h3>



                            <p>

                                Build modern grocery shopping platforms with
                                product catalogs, online ordering, payments,
                                and customer account management.

                            </p>



                        </div>









                        <div className="solution-card">


                            <h3>

                                Inventory Management System

                            </h3>



                            <p>

                                Monitor stock levels, expiry dates, product
                                movement, and automate inventory operations
                                for better control.

                            </p>



                        </div>









                        <div className="solution-card">


                            <h3>

                                Grocery Delivery Platform

                            </h3>



                            <p>

                                Manage delivery operations, order tracking,
                                delivery partners, and customer notifications
                                through smart digital solutions.

                            </p>



                        </div>









                        <div className="solution-card">


                            <h3>

                                POS & Billing Solutions

                            </h3>



                            <p>

                                Simplify checkout processes with digital
                                billing, payment integration, invoices,
                                and transaction management.

                            </p>



                        </div>









                        <div className="solution-card">


                            <h3>

                                Customer Loyalty Platform

                            </h3>



                            <p>

                                Improve customer retention with loyalty
                                programs, offers, rewards, and personalized
                                grocery shopping experiences.

                            </p>



                        </div>









                        <div className="solution-card">


                            <h3>

                                Grocery Marketplace

                            </h3>



                            <p>

                                Connect grocery sellers, suppliers, and
                                customers through scalable marketplace
                                platforms.

                            </p>



                        </div>









                        <div className="solution-card">


                            <h3>

                                Grocery Analytics Dashboard

                            </h3>



                            <p>

                                Analyze sales reports, customer behavior,
                                inventory trends, and business performance
                                using real-time dashboards.

                            </p>



                        </div>






                    </div>





                </div>



            </section>

            {/* =====================================================
            GROCERY FEATURES
===================================================== */}


            <section className="grocery-features">


                <div className="container">


                    <div className="section-heading">


                        <span className="section-tag">

                            Key Features

                        </span>





                        <h2>

                            Powerful Features for a
                            <span> Modern Grocery Platform</span>

                        </h2>





                        <p>

                            Our grocery technology solutions include advanced
                            features designed to automate operations, improve
                            customer experience, and help grocery businesses
                            grow digitally.

                        </p>



                    </div>







                    <div className="features-grid">





                        <div className="feature-card">

                            <h3>

                                Product Management

                            </h3>

                        </div>






                        <div className="feature-card">

                            <h3>

                                Inventory Tracking

                            </h3>

                        </div>






                        <div className="feature-card">

                            <h3>

                                Expiry Date Management

                            </h3>

                        </div>






                        <div className="feature-card">

                            <h3>

                                Online Grocery Ordering

                            </h3>

                        </div>






                        <div className="feature-card">

                            <h3>

                                POS & Billing System

                            </h3>

                        </div>






                        <div className="feature-card">

                            <h3>

                                Supplier Management

                            </h3>

                        </div>






                        <div className="feature-card">

                            <h3>

                                Customer Management

                            </h3>

                        </div>






                        <div className="feature-card">

                            <h3>

                                Delivery Management

                            </h3>

                        </div>






                        <div className="feature-card">

                            <h3>

                                Payment Integration

                            </h3>

                        </div>






                        <div className="feature-card">

                            <h3>

                                Offers & Discounts Management

                            </h3>

                        </div>






                        <div className="feature-card">

                            <h3>

                                Sales Reports & Analytics

                            </h3>

                        </div>






                        <div className="feature-card">

                            <h3>

                                Secure Cloud Platform

                            </h3>

                        </div>





                    </div>




                </div>



            </section>









            {/* =====================================================
            BUSINESS BENEFITS
===================================================== */}



            <section className="grocery-benefits">


                <div className="container">





                    <div className="section-heading">



                        <span className="section-tag">

                            Business Benefits

                        </span>






                        <h2>

                            Why Grocery Businesses Choose
                            <span> Kishancart Digital</span>

                        </h2>







                        <p>

                            Our digital grocery solutions help retailers,
                            supermarkets, and grocery businesses improve
                            efficiency, reduce operational costs, enhance
                            customer satisfaction, and build scalable
                            digital commerce platforms.

                        </p>




                    </div>









                    <div className="benefits-grid">







                        <div className="benefit-card">


                            <h3>

                                Improved Operational Efficiency

                            </h3>



                            <p>

                                Automate grocery operations including inventory,
                                billing, orders, and supplier management to
                                improve daily business efficiency.

                            </p>



                        </div>









                        <div className="benefit-card">


                            <h3>

                                Better Inventory Control

                            </h3>



                            <p>

                                Reduce stock issues, manage product availability,
                                track expiry dates, and optimize inventory
                                management processes.

                            </p>



                        </div>









                        <div className="benefit-card">


                            <h3>

                                Enhanced Customer Experience

                            </h3>



                            <p>

                                Provide faster ordering, personalized services,
                                online shopping, and better customer engagement.

                            </p>



                        </div>









                        <div className="benefit-card">


                            <h3>

                                Increased Sales Growth

                            </h3>



                            <p>

                                Improve revenue opportunities through online
                                grocery platforms, digital marketing, and
                                customer retention solutions.

                            </p>



                        </div>









                        <div className="benefit-card">


                            <h3>

                                Data-Driven Decisions

                            </h3>



                            <p>

                                Use sales reports, analytics, and customer
                                insights to make better business decisions.

                            </p>



                        </div>









                        <div className="benefit-card">


                            <h3>

                                Scalable Grocery Platform

                            </h3>



                            <p>

                                Easily expand grocery operations across
                                multiple stores, locations, and digital
                                commerce channels.

                            </p>



                        </div>





                    </div>





                </div>




            </section>









            {/* =====================================================
                            FOOTER
===================================================== */}



            <Footer />



        </>

    );

};


export default Grocery;